<template>
  <div class="sel_box">
    <!-- v-show="isOutDepartment" -->
    <!-- collapse-tags -->
    <!-- @change="handleChange" -->
    <el-select
      v-model="selectedChannels"
      filterable
      multiple
      :multiple-limit="mulNumber"
      reserve-keyword
      :filter-method="filterMethod"
      :placeholder="placeholder"
      popper-class="coin-select-popper-class"
      :class="className"
      @visible-change="handleVisibleChange"
    >
      <el-checkbox-group v-model="selectedChannels">
        <el-option
          v-for="item in options"
          :key="item[selVal]"
          :label="item[labelName]"
          :value="item[selVal]"
        >
          <el-checkbox
            style="pointer-events: none"
            :label="item[selVal]"
          >
            <slot
              :node="item"
              :data="item"
            >
              {{ item[labelName] }}
            </slot>
          </el-checkbox>
        </el-option>
      </el-checkbox-group>
    </el-select>
  </div>
</template>

<script>
export default {
    name: 'CoinSelect',
    props: {
        // isOutDepartment: {
        //     type: Boolean,
        //     required: true,
        // },
        mulNumber: {
            type: Number,
            default: 0, // 默认不限制
        },
        channels: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: '请选择staff',
        },
        labelName:{
            type: String,
            default: 'departmentName'
        },
        selVal:{
            type: String,
            default: 'departmentID'
        },
        className: {
            type: String,
            default: 'mr10 w240',
        },
    },
    data() {
        return {
            // channels:[],
        };
    },
    computed: {
        selectedChannels: {
            get() {
                return this.channels;
            },
            set(value) {
                this.$emit('update:channels', value);
            },
        },
    },
    created() {
    },
    methods:{
        handleChange(val){
            // 页面多选文字变为“全部顯示+”
            if (val.length > 1) {
                this.$nextTick(() => {
                    const domNodeList = document.querySelectorAll('.custom-select .el-select__tags .el-tag .el-select__tags-text')
                    if (domNodeList.length > 1) {
                        const domNode = document.querySelector('.custom-select .el-select__tags .el-tag:last-child .el-select__tags-text')
                        domNode.innerText = `全部顯示+ ${val.length}`
                    }
                })
            }
        },
        handleVisibleChange(visible) {
            this.$emit('visible-change', visible);
        },
        filterMethod(query) {
            this.$emit('filter-method', query);
        },
    },
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/element-reset.less';
.sel_box{
    display: inline-block;
  
    /deep/.el-select .el-input .el-select__caret.el-input__icon::before {
        content: "\e778";  
    }
    /deep/.el-select .el-input .el-select__caret{
        transform: rotateZ(0deg)
    }
    /deep/.el-select__tags{
        max-width: 195px;
    }
    /deep/.el-tag.el-tag--info{
        max-width: 210px;
    }
    /deep/.el-select__input{
        min-width: 14px;
        margin-left: 5px;
    }
    /deep/.el-input{
        width: 500px;
    }
    /deep/.el-select__tags{
        max-height: 145px;
        overflow-y: auto;
    }
    // .custom-select /deep/.el-select__tags .el-tag:last-child{
    //     background-color: #fff;
    //     border-color: #0062FF;
    //     color: #0062FF;
    //     border-radius: 8px;
    // }
}
</style>